<p-message
    severity="info"
    variant="text"
    closeable
    class="text-center"
    styleClass="w-full text-center !rounded-none">
    <ng-template #container>
        <div class="w-full flex items-center justify-center">
            {{ banner }}
        </div>
    </ng-template></p-message
>
